var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"color/all",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}})
}
var staticRenderFns = []

export { render, staticRenderFns }